<ds-modal [modal]="modal" [title]="'rename_chat_session' | translate" [maxWidthPercentage]="40">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="mb-4">
      <ds-input
        [label]="'label_chat_session_title' | translate"
        [required]="true"
        [errorState]="(titleError$ | async)?.length > 0"
        [errorMessage]="titleError$ | async"
      >
        <input ds-input-field formControlName="title" [maxlength]="charLimit" data-test-id="rename-chat-session-title-input" />
      </ds-input>
    </div>

    <div class="d-flex gap-2">
      <button type="submit" ds-button [intent]="DsButtonIntent.default" data-test-id="rename-chat-session-submit-button">
        {{ 'save_changes' | translate }}
      </button>
      <button
        type="button"
        ds-button
        [variant]="DsButtonVariants.secondary"
        (click)="modal.dismiss()"
        data-test-id="rename-chat-session-cancel-button"
      >
        {{ 'label_cancel' | translate }}
      </button>
    </div>
  </form>
</ds-modal>
